module.exports = __webpack_public_path__ + "img/social04.a6d29075.svg";